import { TrackingCategory } from '@bridebook/web/app-basic/lib/analytics/tracking-category';
import { TrackingEvent } from '@bridebook/web/app-basic/lib/analytics/tracking-event';
import { ThunkAction } from '@bridebook/web/app-basic/lib/types';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';

//Loaded search results on logged out page
export const loadedSearchResultsOnLoggedOutPage: (payload: {
  supplierCountryCode: CountryCodes;
  searchSource?: string;
  searchTerm?: string;
}) => ThunkAction<void> =
  (payload: { supplierCountryCode: CountryCodes }): ThunkAction<void> =>
  (_, __, { analyticsService }) =>
    analyticsService.getMethods(TrackingCategory.LoggedOut).track({
      event: TrackingEvent.LoadedSearchResultsOnLoggedOutPage,
      ...payload,
    });
